/* eslint-disabled */

export default class QueryExtend {


  constructor (object?: any) {
  }

  postConstruct () {
  }
}
